export * from '@fhs/routing/src/routes/(drawer)/_layout';
export { default } from '@fhs/routing/src/routes/(drawer)/_layout';
